import { useState } from 'react'

function SliderComponent({ value, onChange, domainName, onRelease }) {
  const [isDragging, setIsDragging] = useState(false)
  
  // Handle null/undefined values - set to 5 as starting point when user first interacts
  const currentValue = value !== null && value !== undefined ? value : 5
  const hasValue = value !== null && value !== undefined

  const handleChange = (e) => {
    const newValue = parseInt(e.target.value)
    onChange(newValue)
  }

  const handleInteractionStart = () => {
    setIsDragging(true)
    // If no value has been set yet, register the current position (5) immediately
    if (!hasValue) {
      onChange(currentValue)
    }
  }

  const handleInteractionEnd = () => {
    setIsDragging(false)
    // Trigger auto-scroll to next question if callback is provided
    if (onRelease && hasValue) {
      // Small delay to ensure the state update is complete
      setTimeout(() => {
        onRelease()
      }, 100)
    }
  }

  return (
    <div className="space-y-4">
      {/* Slider Labels */}
      <div className="flex justify-between text-sm font-medium text-gray-600">
        <span>
          <strong>Je subis</strong>
        </span>
        <span>
          <strong>Je maîtrise</strong>
        </span>
      </div>

      {/* Slider Container */}
      <div className="relative">
        {/* Background gradient track */}
        <div 
          className={`h-2 rounded-full transition-opacity ${hasValue ? 'slider-gradient' : 'bg-gray-200'}`}
          style={{
            background: hasValue ? `linear-gradient(to right,
              #dc3545 0%, #dc3545 20%,
              #fd7e14 20%, #fd7e14 50%,
              #ffc107 50%, #ffc107 70%,
              #28a745 70%, #28a745 90%,
              #198754 90%, #198754 100%)` : '#e5e7eb',
            opacity: hasValue ? 1 : 0.5
          }}
        />

        {/* Slider Input */}
        <input
          type="range"
          min="0"
          max="10"
          value={currentValue}
          onChange={handleChange}
          onMouseDown={handleInteractionStart}
          onMouseUp={handleInteractionEnd}
          onTouchStart={handleInteractionStart}
          onTouchEnd={handleInteractionEnd}
          className={`
            absolute top-0 left-0 w-full h-2 bg-transparent appearance-none cursor-pointer
            focus:outline-none focus:ring-2 focus:ring-cedec-blue focus:ring-offset-2 rounded-full
            ${isDragging ? 'cursor-grabbing' : 'cursor-grab'}
          `}
          style={{
            background: 'transparent',
          }}
          aria-label={`Niveau de maîtrise pour ${domainName}`}
          aria-valuemin="0"
          aria-valuemax="10"
          aria-valuenow={value}
          aria-valuetext={`${value} sur 10`}
        />


      </div>

      {/* Scale Numbers */}
      <div className="flex justify-between text-xs text-gray-400 px-1">
        {Array.from({ length: 11 }, (_, i) => (
          <span key={i} className="w-4 text-center">
            {i}
          </span>
        ))}
      </div>
    </div>
  )
}

export default SliderComponent
